module.exports = __webpack_public_path__ + "img/en-home-middle.cddca097.png";